import { ReplaySubject } from 'rxjs';
import axios from 'axios';
import { TeamMember } from '@/interfaces/team';

class TeamService {
  private leadershipSubject = new ReplaySubject<TeamMember[]>(1);
  private lolEsportsSubject = new ReplaySubject<TeamMember[]>(1);
  private tekkenEsportsSubject = new ReplaySubject<TeamMember[]>(1);
  private bountyHuntersSubject = new ReplaySubject<TeamMember[]>(1);
  private moderatorsSubject = new ReplaySubject<TeamMember[]>(1);

  getLeadership() {
    return this.leadershipSubject.asObservable();
  }

  getLolEsports() {
    return this.lolEsportsSubject.asObservable();
  }

  getTekkenEsports() {
    return this.tekkenEsportsSubject.asObservable();
  }

  getBountyHunters() {
    return this.bountyHuntersSubject.asObservable();
  }

  getModerators() {
    return this.moderatorsSubject.asObservable();
  }

  async fetchLeadership() {
    const resp = await axios.get('/api/team/leadership');
    this.leadershipSubject.next(resp.data);
  }

  async fetchLolEsports() {
    const resp = await axios.get('/api/team/esports/lol');
    this.lolEsportsSubject.next(resp.data);
  }

  async fetchTekkenEsports() {
    const resp = await axios.get('/api/team/esports/tekken');
    this.tekkenEsportsSubject.next(resp.data);
  }

  async fetchBountyHunters() {
    const resp = await axios.get('/api/team/bounty-hunters');
    this.bountyHuntersSubject.next(resp.data);
  }

  async fetchModerators() {
    const resp = await axios.get('/api/team/moderators');
    this.moderatorsSubject.next(resp.data);
  }
}

export const teamService = new TeamService();
